import { ActivitiesLog } from '@/partials/activities/items';

const ActivityTab = ({ activityData }) => {

  console.log("activityData", activityData);
  return (
    <>
      {activityData?.length > 0 && (
        <div className='flex flex-wrap   mb-5'>

          <div className={`card w-full `}>
            <div className="card-header">
              <h3 className="card-title">Activities </h3>
            </div>
            <div className="card-body pt-4 pb-3 overflow-auto h-72 custom-scrollbar">
              <ActivitiesLog activityData={activityData} />
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export { ActivityTab }